import { useEffect } from 'react';
import { useAnalyticsEvents } from '../../../../../../common/analytics/generated/use-analytics-events';
var AIEventSummaryViewed = function AIEventSummaryViewed(_ref) {
  var _ref$fromCache = _ref.fromCache,
    fromCache = _ref$fromCache === void 0 ? null : _ref$fromCache;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  useEffect(function () {
    fireEvent('ui.summary.viewed', {
      fromCache: fromCache
    });
    if (fromCache) {
      fireEvent('track.aiInteraction.initiated', {
        aiFeatureName: 'Smart Links Summary',
        proactiveAIGenerated: 1,
        userGeneratedAI: 0
      });
    }
  }, [fireEvent, fromCache]);
  return null;
};
export default AIEventSummaryViewed;